import React from 'react';
import { CopyableLink } from 'modules/Common/Copy';
import { accountManagerStyles } from './styled';
import { injectIntl } from 'react-intl';

const AccountManager = ({ className, username, intl }) => {
  const t = intl.messages.modules.shipper_order.card.AccountManager;
  if (!username) {
    return t.no_AM;
  }

  return (
    <div className={className}>
      {t.AM}
      <CopyableLink text={username} weight="bold" />
    </div>
  );
};

export default injectIntl(accountManagerStyles(AccountManager));
